export default __webpack_public_path__ + "static/media/may2023-3.123ca6fd.jpg";